import axiosInstance from "@/shared/api/axiosInstance";

/**
 * Текущий пользователь (для проверки авторизации).
 * @returns {Promise<object|null>}
 */
export const getMe = async () => {
    try {
        const res = await axiosInstance.get("/site/me");
        return res.data;
    } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 400) return null;
        throw error;
    }
};

/**
 * Профиль текущего пользователя
 */
export const getUserProfile = () => {
    return axiosInstance.get("/site/profile");
};

/**
 * История игр пользователя
 */
export const getUserGames = (page = 0, size = 10) => {
    return axiosInstance.get("/site/profile/games/history", {
        params: { page, size },
    });
};

/**
 * Обновление профиля (multipart/form-data)
 */
export const updateProfileData = (formData) => {
    return axiosInstance.put("/site/profile", formData);
};
